import { Controller } from "@hotwired/stimulus";
import axios  from 'axios'

export default class extends Controller {
  static values = {
    reference: String,
    hashedSuccessUrl: String,
    locale: String,
  }

  connect() {
    const { AdyenCheckout, Dropin, Card } = window.AdyenWeb;
    this.AdyenCheckout = AdyenCheckout;
    this.Dropin = Dropin;
    this.paymentForm();
  }

  async paymentForm() {
    try {
      const paymentMethods = await this.getMethods();
      const paymentConfiguration = await this.getPaymentConfiguration();
      const checkout = await this.initializeAdyen(paymentMethods, paymentConfiguration);
      await this.bindForm(checkout);
    } catch(error) {
      this.renderError();
    }
  }

  async getMethods() {
    const response = await axios.get('/adyen_payments/methods', {
      params: { reference: this.referenceValue, locale: this.localeValue } 
    });
    return response.data;
  }

  async getPaymentConfiguration() {
    const response = await axios.get('/adyen_payments/configuration', {
      params: { reference: this.referenceValue } 
    });
    return response.data;
  }

  async initializeAdyen(paymentMethods, paymentConfiguration) {
    let self = this;
    try {
      const configuration = {
        ...paymentConfiguration,
        paymentMethodsResponse: paymentMethods,
        locale: self.localeValue,
        onSubmit: async (submitState, dropin) => {
          const response = await self.makePayment(submitState, dropin);
          const { response: paymentResponse, success_url: successPath } = response.data;

          self.handleResponse(paymentResponse, successPath, dropin);
        },
        onAdditionalDetails: async (threeDSState, dropin, actions) => {
          const response = await self.makePaymentDetails(threeDSState.data)
          const { response: paymentResponse, success_url: successPath } = response.data;

          self.handleResponse(paymentResponse, successPath, dropin);
        }
      };

      return this.AdyenCheckout(configuration);
    } catch(error) {
      console.log(error)
    }
  }

  async bindForm(checkout) {
    this.dropinForm = new this.Dropin(checkout, {
      openFirstPaymentMethod: true,
      openFirstStoredPaymentMethod: true,
      paymentMethodsConfiguration: {
        card: {
          // holderName: self.fullNameValue,
          hasHolderName: true,
          holderNameRequired: true,
          enableStoreDetails: true,
          name: 'Credit or debit card',
          challengeWindowSize: "04"
        }
      }
    }).mount('#adyen-dropin');
  }
  
  async makePayment(submitState, dropin) {
    try {
      console.log(submitState);
      return axios.post(`/adyen_payments/payment`, { 
        submit_state: submitState.data,
        reference: this.referenceValue,
        returnUrl: window.location.href,
        hashed_success_url: this.hashedSuccessUrlValue
      });
    } catch(error) {
      console.log(error);
      dropin.setStatus('error', { message: error.message });
    }
  }

  async makePaymentDetails(data) {
    try {
      console.log('3ds payment - onAdditionalDetails callback', data);
      return axios.post(`/adyen_payments/details`, { result: data, reference: this.referenceValue, hashed_success_url: this.hashedSuccessUrlValue });
    } catch(error) {
      console.log(error)
    }
  }

  handleResponse(response, successPath, dropin) {
    if (this.isSuccessPayment(response)) {
      dropin.setStatus('success', { message: 'Payment successful!' });
      this.redirectToSuccessPage(successPath);
    } else if (this.is3DS2Payment(response)) {
      dropin.handleAction(response.action);      
    } else if (this.isRedirectAction(response)) {
      dropin.handleAction(response.action);      
    } else {
      let errorMsg = response.refusalReason || response.message || "An unknown error occurred";
      dropin.setStatus('error', { message: errorMsg });
      this.reloadForm();
    }
  }

  isSuccessPayment(response) {
    return response.resultCode == 'Authorised'
  }

  is3DS2Payment(response) {
    return response.action && response.action.type == "threeDS2"
  }
  
  isRedirectAction(response) {
    return response.resultCode == "RedirectShopper"
  }

  redirectToSuccessPage(hashed_success_url) {
    setTimeout(() => window.location.assign(hashed_success_url), 3000)
  }

  reloadForm() {
    setTimeout(() => window.location.reload(), 3000);
  }

  renderError() {
    document.querySelector('#adyen-dropin').appendChild(this.errorPanel());
  }

  errorPanel() {
    let errorElement = document.createElement('div');
    errorElement.classList.add('text-center','align-middle');
    errorElement.innerText = `Unable to initialize payment session`

    return errorElement;
  }
}
